import type { ManifestRouteDefinition } from '@/core/manifest/types'

export const commonManifestRoutes: ManifestRouteDefinition[] = []
